import React from 'react';
import './wrkthru.css';

export function WrkthruLoading() {
  const grad = `url(#wrkthru-loading-grad)`;
  return (
    <div
      className="flex flex-col items-center justify-center gap-2"
      role="status"
      aria-live="polite">
      <svg
        viewBox="0 0 400 300"
        width={400}
        height={300}
        role="img"
        aria-label="Wrkthru is prioritizing your day">
        <title>Wrkthru_ is prioritizing your day…</title>
        <defs>
          <linearGradient id={'wrkthru-loading-grad'} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#b6a258" />
            <stop offset="55%" stopColor="#bc45d3" />
            <stop offset="100%" stopColor="#e040fb" />
          </linearGradient>
        </defs>

        <ellipse cx="205" cy="248" rx="120" ry="20" fill="#0077b6" opacity="0.06" />

        <g transform="translate(200 150)">
          <g transform="skewY(-26) scale(1 1.04)">
            <path d="M-95 6 L75 6 L75 22 L-95 22 Z" fill="#0077b6" opacity="0.35" />
            <rect
              x="-95"
              y="-72"
              width="170"
              height="80"
              rx="7"
              fill="#ffffff"
              stroke="#e2e8f0"
              strokeWidth="1.2"
            />
            <rect x="-95" y="-72" width="170" height="80" rx="7" fill="#0077b6" opacity="0.04" />

            <rect x="-84" y="-63" width="46" height="6" rx="3" fill={grad} />
            <rect x="-30" y="-63" width="26" height="6" rx="3" fill="#0077b6" opacity="0.35" />

            <g transform="translate(-84 -10)">
              <rect x="0" y="-6" width="9" height="6" rx="1.5" fill={grad}>
                <animate
                  attributeName="height"
                  values="6;26;6"
                  dur="3.6s"
                  repeatCount="indefinite"
                  begin="0s"
                  calcMode="spline"
                  keyTimes="0;0.5;1"
                  keySplines="0.45 0 0.55 1;0.45 0 0.55 1"
                />
                <animate
                  attributeName="y"
                  values="-6;-26;-6"
                  dur="3.6s"
                  repeatCount="indefinite"
                  begin="0s"
                  calcMode="spline"
                  keyTimes="0;0.5;1"
                  keySplines="0.45 0 0.55 1;0.45 0 0.55 1"
                />
              </rect>
              <rect x="13" y="-6" width="9" height="6" rx="1.5" fill="#0077b6">
                <animate
                  attributeName="height"
                  values="10;30;10"
                  dur="3.6s"
                  repeatCount="indefinite"
                  begin="0.45s"
                  calcMode="spline"
                  keyTimes="0;0.5;1"
                  keySplines="0.45 0 0.55 1;0.45 0 0.55 1"
                />
                <animate
                  attributeName="y"
                  values="-10;-30;-10"
                  dur="3.6s"
                  repeatCount="indefinite"
                  begin="0.45s"
                  calcMode="spline"
                  keyTimes="0;0.5;1"
                  keySplines="0.45 0 0.55 1;0.45 0 0.55 1"
                />
              </rect>
              <rect x="26" y="-6" width="9" height="6" rx="1.5" fill="#0077b6" opacity="0.55">
                <animate
                  attributeName="height"
                  values="8;22;8"
                  dur="3.6s"
                  repeatCount="indefinite"
                  begin="0.9s"
                  calcMode="spline"
                  keyTimes="0;0.5;1"
                  keySplines="0.45 0 0.55 1;0.45 0 0.55 1"
                />
                <animate
                  attributeName="y"
                  values="-8;-22;-8"
                  dur="3.6s"
                  repeatCount="indefinite"
                  begin="0.9s"
                  calcMode="spline"
                  keyTimes="0;0.5;1"
                  keySplines="0.45 0 0.55 1;0.45 0 0.55 1"
                />
              </rect>
              <rect x="39" y="-6" width="9" height="6" rx="1.5" fill="#0077b6" opacity="0.35">
                <animate
                  attributeName="height"
                  values="14;34;14"
                  dur="3.6s"
                  repeatCount="indefinite"
                  begin="1.35s"
                  calcMode="spline"
                  keyTimes="0;0.5;1"
                  keySplines="0.45 0 0.55 1;0.45 0 0.55 1"
                />
                <animate
                  attributeName="y"
                  values="-14;-34;-14"
                  dur="3.6s"
                  repeatCount="indefinite"
                  begin="1.35s"
                  calcMode="spline"
                  keyTimes="0;0.5;1"
                  keySplines="0.45 0 0.55 1;0.45 0 0.55 1"
                />
              </rect>
              <rect x="-2" y="0" width="52" height="1" fill="#e2e8f0" />
            </g>

            <g transform="translate(-22 -52)">
              <rect x="0" y="0" width="64" height="40" fill="#f1f5f9" rx="3" />
              <polyline
                points="3,34 16,24 28,28 40,12 52,18 61,5"
                fill="none"
                stroke={grad}
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeDasharray="120"
                strokeDashoffset="120">
                <animate
                  attributeName="stroke-dashoffset"
                  values="120;0;0;120"
                  keyTimes="0;0.55;0.85;1"
                  dur="4.5s"
                  repeatCount="indefinite"
                />
                <animate
                  attributeName="opacity"
                  values="1;1;1;0.15;1"
                  keyTimes="0;0.55;0.85;0.95;1"
                  dur="4.5s"
                  repeatCount="indefinite"
                />
              </polyline>
              <rect x="3" y="40" width="40" height="0" opacity="0" />
            </g>

            <rect x="-22" y="-8" width="40" height="3" rx="1.5" fill="#0077b6" opacity="0.35" />
            <rect x="-22" y="-1" width="56" height="3" rx="1.5" fill="#0077b6" opacity="0.2" />
          </g>
        </g>

        <g transform="translate(70 78)">
          <g>
            <path
              d="M13.00,2.00 L18.56,6.07 L16.00,12.24 L9.19,11.19 L10.24,18.00 L4.07,20.56 L0.00,15.00 L-4.07,20.56 L-10.24,18.00 L-9.19,11.19 L-16.00,12.24 L-18.56,6.07 L-13.00,2.00 L-18.56,-2.07 L-16.00,-8.24 L-9.19,-7.19 L-10.24,-14.00 L-4.07,-16.56 L-0.00,-11.00 L4.07,-16.56 L10.24,-14.00 L9.19,-7.19 L16.00,-8.24 L18.56,-2.07 Z"
              fill="#0077b6"
            />
            <circle cx="0" cy="2" r="6" fill="#ffffff" />
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 0 2"
              to="360 0 2"
              dur="11s"
              repeatCount="indefinite"
            />
          </g>
        </g>
        <g transform="translate(98 64)">
          <g>
            <path
              d="M8.50,1.00 L12.21,3.68 L10.53,7.74 L6.01,7.01 L6.74,11.53 L2.68,13.21 L0.00,9.50 L-2.68,13.21 L-6.74,11.53 L-6.01,7.01 L-10.53,7.74 L-12.21,3.68 L-8.50,1.00 L-12.21,-1.68 L-10.53,-5.74 L-6.01,-5.01 L-6.74,-9.53 L-2.68,-11.21 L-0.00,-7.50 L2.68,-11.21 L6.74,-9.53 L6.01,-5.01 L10.53,-5.74 L12.21,-1.68 Z"
              fill={grad}
            />
            <circle cx="0" cy="1" r="4" fill="#ffffff" />
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="360 0 1"
              to="0 0 1"
              dur="8s"
              repeatCount="indefinite"
            />
          </g>
        </g>

        <g transform="translate(72 210)">
          <circle r="20.5" fill="#ffffff" stroke="#e2e8f0" strokeWidth="1" />
          <g transform="rotate(-90)" fill="none" strokeLinecap="butt">
            <circle
              r="13.5"
              stroke={grad}
              strokeWidth="13"
              strokeDasharray="42.41 42.41"
              strokeDashoffset="0.00">
              <animate
                attributeName="stroke-dasharray"
                values="42.41 42.41;21.21 63.62;27.99 56.83;42.41 42.41"
                keyTimes="0;0.4;0.75;1"
                dur="5s"
                repeatCount="indefinite"
                calcMode="spline"
                keySplines="0.45 0 0.55 1;0.45 0 0.55 1;0.45 0 0.55 1"
              />
              <animate
                attributeName="stroke-dashoffset"
                values="0.00;0.00;0.00;0.00"
                keyTimes="0;0.4;0.75;1"
                dur="5s"
                repeatCount="indefinite"
                calcMode="spline"
                keySplines="0.45 0 0.55 1;0.45 0 0.55 1;0.45 0 0.55 1"
              />
            </circle>
            <circle
              r="13.5"
              stroke="#0077b6"
              strokeWidth="13"
              strokeDasharray="25.45 59.38"
              strokeDashoffset="-42.41">
              <animate
                attributeName="stroke-dasharray"
                values="25.45 59.38;38.17 46.65;18.66 66.16;25.45 59.38"
                keyTimes="0;0.4;0.75;1"
                dur="5s"
                repeatCount="indefinite"
                calcMode="spline"
                keySplines="0.45 0 0.55 1;0.45 0 0.55 1;0.45 0 0.55 1"
              />
              <animate
                attributeName="stroke-dashoffset"
                values="-42.41;-21.21;-27.99;-42.41"
                keyTimes="0;0.4;0.75;1"
                dur="5s"
                repeatCount="indefinite"
                calcMode="spline"
                keySplines="0.45 0 0.55 1;0.45 0 0.55 1;0.45 0 0.55 1"
              />
            </circle>
            <circle
              r="13.5"
              stroke="rgba(0,119,182,0.5)"
              strokeWidth="13"
              strokeDasharray="16.96 67.86"
              strokeDashoffset="-67.86">
              <animate
                attributeName="stroke-dasharray"
                values="16.96 67.86;25.45 59.38;38.17 46.65;16.96 67.86"
                keyTimes="0;0.4;0.75;1"
                dur="5s"
                repeatCount="indefinite"
                calcMode="spline"
                keySplines="0.45 0 0.55 1;0.45 0 0.55 1;0.45 0 0.55 1"
              />
              <animate
                attributeName="stroke-dashoffset"
                values="-67.86;-59.38;-46.65;-67.86"
                keyTimes="0;0.4;0.75;1"
                dur="5s"
                repeatCount="indefinite"
                calcMode="spline"
                keySplines="0.45 0 0.55 1;0.45 0 0.55 1;0.45 0 0.55 1"
              />
            </circle>
          </g>
          <circle r="7" fill="#ffffff" />
        </g>

        <g transform="translate(330 150)">
          <g>
            <polyline
              points="-14,18 -4,6 4,12 18,-10"
              fill="none"
              stroke={grad}
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <polyline
              points="9,-10 18,-10 18,-1"
              fill="none"
              stroke={grad}
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <animateTransform
              attributeName="transform"
              type="translate"
              values="0 4; 0 -2; 0 4"
              dur="4s"
              repeatCount="indefinite"
              calcMode="spline"
              keyTimes="0;0.5;1"
              keySplines="0.45 0 0.55 1;0.45 0 0.55 1"
            />
            <animate
              attributeName="opacity"
              values="0.55;1;0.55"
              dur="4s"
              repeatCount="indefinite"
            />
          </g>
        </g>

        <g transform="translate(312 86)">
          <rect x="0" y="0" width="22" height="5" rx="2.5" fill={grad} />
          <rect x="0" y="8" width="16" height="5" rx="2.5" fill="#0077b6" opacity="0.55" />
          <rect x="0" y="16" width="10" height="5" rx="2.5" fill="#0077b6" opacity="0.35" />
        </g>
      </svg>

      <p className="wrkthru-gradient-text text-base font-semibold tracking-wide">
        Generating Daily Briefing
        <span aria-hidden="true">
          <span className="animate-pulse">.</span>
          <span className="animate-pulse [animation-delay:0.2s]">.</span>
          <span className="animate-pulse [animation-delay:0.4s]">.</span>
        </span>
      </p>
    </div>
  );
}
